import styled from 'styled-components';
import { ReactComponent as ChevronUp } from '../media/chevron-up.svg';
import { useTranslation } from "react-i18next";
import { namespaces } from "../i18n.costants";
import { AnchorHTMLAttributes } from 'react';

export function BackToTopButton() {
  const { t } = useTranslation(namespaces.common);

  return (
    <Wrapper title="back-to-top" href={`#${t("nav/home")}`}>
      <ChevronUp stroke="var(--color-blue)" />
    </Wrapper>
  )
}

const Wrapper = styled.a<AnchorHTMLAttributes<HTMLAnchorElement>>`
  width: 34px;
  height: 34px;
  position: fixed;
  bottom: 6em;
  right: 1em;
  z-index: 2;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-gray-light);
  border-radius: 50%;
  box-shadow: 3px 5px 15px rgba(0,0,0,0.2);

  @media (pointer:none), (pointer:coarse) {
    display: none;
  }
`;

